import { CreateFieldSectionPayload } from '.';

export enum FieldSectionType {
  Project = 'PROJECT',
  Task = 'TASK',
  Users = 'USERS',
  Financial = 'FINANCIAL',
}

export interface FieldSection extends CreateFieldSectionPayload {
  fieldSectionId: number;
  default: boolean;
  fixed: boolean;
  createdBy: number;
  fieldOrder: number[];
}
